export default __webpack_public_path__ + "static/media/twitter-black.96500dff.svg";